// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__1Hwek","title":"Partners_title__2AHSf","logos":"Partners_logos__2FKmz"};